import { Card as CardAntDesign } from 'antd';
import { CardProps } from 'antd/lib/card';
import cardStyles from './Card.module.css';
type Props = CardProps;
const Card = ({ className, styles, ...props }: Props) => (
    <CardAntDesign
        styles={{
            ...styles,
            extra: {
                ...styles?.extra,
                padding: '16px 0',
            },
        }}
        className={`${cardStyles.card} ${className}`}
        {...props}
    />
);
export { Card };
